export default __webpack_public_path__ + "static/media/OpenSans-Bold.2d8169f0.svg";